import { initializeScript } from '@src/telemetry/integrations/provider-utils/initialize-script'

import { TelemetryIntegration } from '../telemetry-events.types'
import { TELEMETRY_DOMAINS } from '../telemetry-domains.constants'

export const LiveConnect: TelemetryIntegration = {
  config: {
    enabled: true,
    eventIdealTimeout: 1000,
    domain: TELEMETRY_DOMAINS.LIVECONNECT,
  },
  initialize: async () => {
    encodeURIComponent(window.location.href)
    await initializeScript({
      key: 'livecode-connect',
      domain: TELEMETRY_DOMAINS.LIVECONNECT,
      path: '/a-07pa.min.js',
    })
  },
}
